module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAMBAMAAABGh1qtAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAbUExURf///////////0dwTP///////////////////zX5XqIAAAAJdFJOUzyQ6QDXGH9TH++SD2QAAABHSURBVAjXYxAwFjA2NmBgYmZiBlIGCgYKQMoYxAVSIC6QAnEZgJRIs0gDg7Ghq6ErUFAkWCTYgAHEAWpICU4JBlKlxqVAwwDA8w0btZlTIAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/case-more.png
// module id = 7SPh
// module chunks = 0